import * as React from 'react';
import * as moment from 'moment';

import { connect, Dispatch} from 'react-redux';

import ListProductionView from 'list-addon-production.view';
import { IAddOnsAppState } from '../../redux-state';
import { IAddOnsAppText } from '../../custom/classes/add-ons-text';
import { IAddOnProduction } from '../../custom/classes/production';

interface IListProductionExternalProps {
    production: IAddOnProduction;
}


interface StateToProps {
    text: IAddOnsAppText;
    addedToCart: boolean;
    performanceAvailable: boolean;
    performancesCount: number;
}

interface DispatchToProps {
    displayLoading(enable: boolean): void;
}

interface ListProductionViewState {
    showPerfsPanel: boolean;
    showSynopsis: boolean;
}

interface ListProductionViewProps {
    togglePerformancesPanel(): void;
    toggleSynopsis(): void;
}


interface ViewProps {

}

export type ListProductionProps = IListProductionExternalProps & StateToProps & DispatchToProps;

export type CombinedProductionViewProps = ListProductionProps & ListProductionViewState & ViewProps & ListProductionViewProps ;

export class ListProductionBase extends React.Component<ListProductionProps, ListProductionViewState> {

    constructor(props: ListProductionProps) {
        super(props);
        this.state = {
            showPerfsPanel: false,
            showSynopsis: false
        }
        this.props.displayLoading(true);
    }
    _togglePerformancePanel(): void {
        this.setState({
            showPerfsPanel: !this.state.showPerfsPanel
        });
        if (!this.state.showPerfsPanel) {
            this.props.displayLoading(true);
        }
    }

    _toggleSynopsis(): void {
        this.setState({
            showSynopsis: !this.state.showSynopsis
        });
    }
  
    componentDidUpdate(prevProps, prevState) {
            var result = this.props.production.performances.every(perf => perf.performancePricing !== undefined || perf.unavailable);
        if (result) {
            this.props.displayLoading(false);
        } else {
            this.props.displayLoading(true);
        }
    }

    render() {
        return (
            <ListProductionView {...this.props} {...this.state} togglePerformancesPanel={this._togglePerformancePanel.bind(this)} toggleSynopsis={this._toggleSynopsis.bind(this)} />
        )
    }
}

function mapStateToProps(state: IAddOnsAppState, ownProps: IListProductionExternalProps): StateToProps {
    var currentProd = state.addOns.addOnProductions.filter((prod) => prod.id == ownProps.production.id)[0];
    var performancesForProd = currentProd
        .performances.map(perf => perf.id);
    var productionUnavailable = currentProd.performances.every(perf => perf.unavailable);
    var cartContainsProd = false;
    if (!state.addOnsText.seatedAddon)
        cartContainsProd = state.addOns.reserveRequests.some(req => performancesForProd.indexOf(req.performanceId) > -1 && req.zoneId > 0 && req.priceTypeQuantity.size > 0);
    else
        cartContainsProd = state.addOns.reserveRequests.some(req => performancesForProd.indexOf(req.performanceId) > -1);
    return {
        text: state.addOnsText,
        addedToCart: cartContainsProd,
        performanceAvailable: currentProd.performances.length > 0 && !productionUnavailable,
        performancesCount: currentProd.performances.length
    }
}

export default connect<StateToProps>(mapStateToProps)(ListProductionBase);